import { createAction, props } from '@ngrx/store';

import { ErrorMessage, MocketBankAccount, MocketBankList, RequestPageParams } from '@shared/models';

export namespace MocketBankAccountActions {
  export const loadMocketBankAccounts = createAction('[MocketBank API] Load MocketBank', props<{ params: RequestPageParams }>());

  export const loadMocketBankAccountSuccess = createAction(
    '[MocketBank API] Load MocketBank Accounts Success',
    props<{ mocketBankAccounts: MocketBankList['items']; totalElements: number }>(),
  );

  export const loadMocketBankAccountError = createAction('[MocketBank API] Load MocketBank Error', props<{ error: ErrorMessage }>());

  export const setMocketBankAccount = createAction('[Active MocketBank Account] Set', props<{ selectedAccount: MocketBankAccount }>());
}
